import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BrandMark } from "../art/Icons";
import { BRAND_NAME } from "../../config/event";

const LOGIN_ENDPOINT = "/backend/admin_login.php";
export const ADMIN_STORAGE_KEY = "adminUser";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
    setError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch(LOGIN_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem(ADMIN_STORAGE_KEY, JSON.stringify(data.admin));
        navigate("/admin/dashboard");
      } else {
        setError(data.error || "Login failed");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="centered-screen">
      <div className="card main w-full max-w-md">
        <Link className="brand justify-center" to="/">
          <BrandMark />
          {BRAND_NAME}
        </Link>
        <h3>Admin login</h3>
        <p className="desc">Access the reservation management console</p>

        <form onSubmit={handleSubmit} className="grid gap-4">
          <div className="field">
            <label htmlFor="admin-email">Email address</label>
            <input
              type="email"
              id="admin-email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="admin@utb.cz"
              autoComplete="username"
            />
          </div>
          <div className="field">
            <label htmlFor="admin-password">Password</label>
            <input
              type="password"
              id="admin-password"
              name="password"
              value={form.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>
          {error && (
            <p className="msg error" role="alert">
              {error}
            </p>
          )}
          <button type="submit" className="btn btn-marigold" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="already">
          <Link to="/">← Back to home</Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
